import { useState } from "react";
import { useNotify } from "../hooks/useNotify";
import IconButton from "@mui/joy/IconButton";
import { accessTokenManager } from "../models/AccessTokenManager";
import UploadIcon from "@mui/icons-material/Upload";
export interface FileUploadButtonProps {
  isPublic?: boolean;
  multiple?: boolean;
  onSuccess?: (files: { uniqueId: string }[]) => void;
  onProgress?: (
    files: { name: string; size: number; type: string }[],
    progress: number
  ) => void;
}

function FileUploadButton({
  multiple,
  isPublic,
  onSuccess,
  onProgress,
}: FileUploadButtonProps) {
  const [progress, setProgress] = useState(0);
  const notify = useNotify();

  const handleFileChange = async (e: any) => {
    const formData = new FormData();
    let files: { name: string; size: number; type: string }[] = [];
    for (const file of e.target.files) {
      files.push(file);
      formData.append("file", file);
    }

    try {
      const xhr = new XMLHttpRequest();

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percentComplete = Math.round(
            (event.loaded / event.total) * 100
          );
          onProgress && onProgress(files, percentComplete);
          setProgress(percentComplete);
        }
      };

      xhr.open(
        "POST",
        process.env.REACT_APP_FILES_URL! + (isPublic ? "/public" : ""),
        true
      );
      xhr.setRequestHeader(
        "authorization",
        `Bearer ${accessTokenManager.retrieve()}`
      );
      xhr.send(formData);

      xhr.onload = () => {
        if (xhr.status === 200) {
          notify({
            type: "success",
            msg: "The file(s) upload was successful.",
          });

          if (typeof onSuccess === "function") {
            const response = JSON.parse(xhr.responseText);
            onSuccess(response.files);
          }
        } else {
          notify({
            type: "danger",
            msg: "The file(s) upload has failed.",
          });
        }
      };
    } catch (error) {
      console.error("Upload error:", error);
      notify({
        type: "danger",
        msg: "The file(s) upload has failed.",
      });
    }
  };

  return (
    <IconButton
      component={"label"}
      variant="soft"
      color="neutral"
      disabled={typeof progress === "number" && progress !== 100}
    >
      <>
        <input
          id="uploader"
          type="file"
          multiple={multiple}
          hidden
          onChange={handleFileChange}
        />
        <UploadIcon />
      </>
    </IconButton>
  );
}

export default FileUploadButton;
